// #region IMPORT
import { Box, Stack, Button, Container, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

// #endregion

const circleOne = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="631"
    height="641"
    viewBox="0 0 631 641"
    fill="none"
  >
    <g filter="url(#filter0_f_1362_57965)">
      <circle cx="167.5" cy="178.25" r="87.75" fill="#FF9900" />
    </g>
    <defs>
      <filter
        id="filter0_f_1362_57965"
        x="-295.25"
        y="-284.5"
        width="925.5"
        height="925.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="187.5" result="effect1_foregroundBlur_1362_57965" />
      </filter>
    </defs>
  </svg>
);

const circleTwo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="927"
    height="860"
    viewBox="0 0 927 860"
    fill="none"
  >
    <g filter="url(#filter0_f_1362_57966)">
      <circle cx="463.625" cy="397" r="87.75" fill="#D24B53" />
    </g>
    <defs>
      <filter
        id="filter0_f_1362_57966"
        x="0.875"
        y="-65.75"
        width="925.5"
        height="925.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="187.5" result="effect1_foregroundBlur_1362_57966" />
      </filter>
    </defs>
  </svg>
);

const circleThree = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="631"
    height="729"
    viewBox="0 0 631 729"
    fill="none"
  >
    <g filter="url(#filter0_f_1362_57967)">
      <circle cx="463.5" cy="266" r="87.75" fill="#5E4BD2" />
    </g>
    <defs>
      <filter
        id="filter0_f_1362_57967"
        x="0.75"
        y="-196.75"
        width="925.5"
        height="925.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="187.5" result="effect1_foregroundBlur_1362_57967" />
      </filter>
    </defs>
  </svg>
);

interface Props {
  onOpenRegisterForm: (value: boolean) => void;
}

export const AiView = ({ onOpenRegisterForm }: Props) => {
  const smUp = useResponsive('up', 'sm');

  return (
    <Stack position="relative" overflow="clip">
      <Box position="absolute" zIndex={0} top={0} left={0}>
        {circleOne}
      </Box>
      <Box
        position="absolute"
        zIndex={0}
        top={50}
        left="50%"
        sx={{
          transform: 'translateX(-50%)',
        }}
      >
        {circleTwo}
      </Box>
      <Box position="absolute" zIndex={0} top={0} right={0}>
        {circleThree}
      </Box>
      <Container sx={{ zIndex: 1 }}>
        <Stack py={{ xs: 6, sm: 6, md: 10 }} spacing={10} height={1} alignItems="center">
          <Stack alignItems="center">
            <Typography
              variant="body2"
              fontFamily='"Shantell Sans Light", sans-serif'
              fontWeight="bold"
              color="primary.main"
            >
              Cá nhân hóa học tập, kết nối phụ huynh
            </Typography>
            <Typography mt={2} variant="h2" fontWeight="bold" textAlign="center">
              Sổ liên lạc điện tử
            </Typography>
            <Typography
              textAlign="center"
              px={smUp ? 15 : 5}
              mt={2.5}
              mb={5}
              fontWeight="light"
              maxWidth={1000}
            >
              Cập nhật tiến độ học tập, kết quả học tập theo thời gian thực. Giúp trung tâm chăm sóc
              học viên tốt hơn và phụ huynh luôn đồng hành dễ dàng, mọi lúc mọi nơi.
            </Typography>
            <Button
              variant="contained"
              onClick={() => onOpenRegisterForm(true)}
              size="large"
              color="primary"
            >
              Đăng ký Demo
            </Button>
          </Stack>
          <Stack direction={smUp ? 'row' : 'column'} spacing={2.5} width={1} height={1}>
            <Stack flex={0.5} height={1}>
              <Box component="img" src="/assets/landing/ai/study_result.png" />
            </Stack>
            <Stack flex={0.5} spacing={1.5} height={1}>
              <Box component="img" src="/assets/landing/ai/study_progress.png" />
              <Box component="img" src="/assets/landing/ai/study_response.png" />
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};
